<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>商学院课程管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/stuCourseList')">商学院课程列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns">
        <!-- <li>
          <el-button type="primary">导出</el-button>
        </li> -->
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='分类名称'>
            <el-input
              clearable
              style="width:500px"
              v-model="filters.keyword"
              placeholder="请输入名称搜索"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-select
              v-model="filters.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="待上架"
                value="1"
              ></el-option>
              <el-option
                label="已上架"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程类型">
            <el-select
              v-model="filters.infoType"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="线上"
                value="1"
              ></el-option>
              <el-option
                label="线下"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button v-if="hasPower('90016991')"
              type="success"
              @click="addPostDialog"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="id"
            label="编号"
          >
          </el-table-column>
          <el-table-column
            label="标题"
            prop="title"
          >
          </el-table-column>

          <el-table-column
            label="排序值"
            prop="order_index"
          >
          </el-table-column>

          <el-table-column
            prop="info_type"
            label="类型"
          >
          <template slot-scope="scope">
              <span v-if="scope.row.info_type == 1">线上</span>
              <span v-else>线下</span>
            </template>
          </el-table-column>

           <el-table-column
            label="课程分类"
            prop="type_name"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type_name != null">{{scope.row.type_name}}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>


          <el-table-column
            prop="video_url"
            label="线上课程视频"
          >
          <template slot-scope="scope">
              <a v-if="scope.row.info_type == 1" :href="scope.row.video_url" target="_blank">查看</a>
              <span v-else>--</span>
            </template>
          </el-table-column>

            <el-table-column
            :formatter="formatterRoleType"
            prop="role_type"
            label="对应角色"
          >
          </el-table-column>

          <el-table-column
            label="主讲人"
            prop="speak_user"
          >
          </el-table-column>

          <el-table-column
            label="总人数"
            prop="total_num"
          >
          </el-table-column>

          <el-table-column label="封面">
            <template slot-scope="scope">
              <img
                :src="scope.row.info_type == 1 ? scope.row.video_cover : scope.row.speak_head"
                style="width:50px;"
              >
            </template>
          </el-table-column>

          <el-table-column
            label="时长"
            prop="video_time"
          >
          </el-table-column>

          <el-table-column label="主讲人头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.info_type == 1 ? scope.row.speak_head : ''"
                style="width:50px;"
              >
            </template>
          </el-table-column>

          <el-table-column
            label="创建时间"
            prop="create_time"
            width="200px"
          >
          </el-table-column>



          <el-table-column
            prop="status"
            label="上架状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 1"
                type="success"
                disable-transitions
              >待上架</el-tag>
              <el-tag
                v-if="scope.row.status == 2"
                type="info"
                disable-transitions
              >已上架</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="code" label="预约码" min-width="150">
            <template slot-scope="scope">
              <el-button v-if="scope.row.info_type == 2" type="text" @click="creatQrCode(scope.row)">查看二维码</el-button>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column
            label="学习积分"
            prop="integral"
          >
            <template slot-scope="scope">
              <div>{{scope.row.integral == null ? 0 : scope.row.integral}}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="学习人数"
            prop="userNum"
          >
            <template slot-scope="scope">
              <div>{{scope.row.userNum == null ? 0 : scope.row.userNum}}</div>
            </template>
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                v-if="hasPower('90016991') && scope.row.status == 1"
                @click="upHouseStatus(scope.row, 2)"
                type="text"
                size="small"
              >上架</el-button>
              <el-button
                v-if="hasPower('90016991') && scope.row.status == 2"
                @click="upHouseStatus(scope.row, 1)"
                type="text"
                size="small"
              >取消上架</el-button>
              <el-button v-if="hasPower('90016991')"
                @click="editPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>
              <el-button v-if="hasPower('90016991')"
                @click="upHouseStatus(scope.row, 3)"
                type="text"
                size="small"
              >删除</el-button>
              <el-button
                @click="showStuUser(scope.row)"
                type="text"
                size="small"
              >查看学习人员</el-button>
              <el-button
                @click="showUserMsg(scope.row)"
                type="text"
                size="small"
              >查看录入信息</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="二维码"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <div><div id="qrCodeUrl" class="qrcode" ref="qrCodeUrl"></div></div>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="dialogEditVisible"
      width="40%"
    >

      <el-form
        label-position="left"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item

          label="标题"
          prop='title'
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>

        <el-row  :gutter="20">
        <el-col :span="10">
          <el-form-item

          label="排序值"
          prop='orderIndex'
        >
          <el-input v-model="form.orderIndex" type="number"></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="10" >
         

        <el-form-item
          label="积分"
          prop='integral'
        >
          <el-input v-model="form.integral"></el-input>
        </el-form-item>

        </el-col>
        
      </el-row>


        <el-row  :gutter="20">
        <el-col :span="10">
          
        <el-form-item
          label="课程类型"
          prop="infoType"
        >
          <el-select
            v-model="form.infoType"
            placeholder="请选择"
          >
            <el-option
              v-for="option in recoOptions"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        </el-col>
        <el-col :span="10" >
         

        <el-form-item
          label="课程类别"
          prop="stuType"
        >
          <el-select
            v-model="form.stuType"
            placeholder="请选择"
          >
            <el-option
              v-for="option in stuTypeList"
              :value="option.id"
              :key='option.id'
              :label="option.typeName"
            ></el-option>
          </el-select>
        </el-form-item>

        </el-col>
        
      </el-row>


       


         <el-form-item
 v-show='form.infoType == 1'
          label="时长"
          prop='videoTime'
        >
          <el-input type="number" v-model="form.videoTime"></el-input>
        </el-form-item>

        <el-form-item  v-show='form.infoType == 1' label="视频封面" prop="videoCover">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.videoCover" :src="form.videoCover" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

           <el-form-item  v-show='form.infoType == 1' label="主讲人头像" prop="speakHead">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess1"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.speakHead" :src="form.speakHead" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

          <el-form-item  v-show='form.infoType == 2' label="封面" prop="speakHead">
           <el-upload
             class="avatar-uploader"
             action="/manager/user/seven_app_file_up"
             :show-file-list="false"
             :data="tokenData"
             :on-success="handleAvatarSuccess1"
             :before-upload="beforeAvatarUpload"
           >
             <img v-if="form.speakHead" :src="form.speakHead" class="avatar" />
             <i v-else class="el-icon-plus avatar-uploader-icon"></i>
             <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
           </el-upload>
         </el-form-item>

        <el-form-item
          label="主讲人"
          prop='speakUser'
        >
          <el-input v-model="form.speakUser"></el-input>
        </el-form-item>


        <el-form-item
          v-show='form.infoType == 1'
          label="对应角色"
          prop="roleType"
        >
          <el-select
            v-model="form.roleType"
            placeholder="请选择"
          >
            <el-option
              v-for="option in roleTypeList"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
        v-show='form.infoType == 1'
          label="视频连接"
          prop='videoUrl'
        >
          <el-input v-model="form.videoUrl"></el-input>
        </el-form-item>

        <el-form-item
        v-show='form.infoType == 2'
          label="地点"
          prop='address'
        >
          <el-input v-model="form.address"></el-input>
        </el-form-item>

        <el-form-item
        v-show='form.infoType == 2'
          label="总人数"
          prop='totalNum'
        >
          <el-input v-model="form.totalNum" type="number"></el-input>
        </el-form-item>


        <el-row  :gutter="20">
        <el-col :span="10">
          
        <el-form-item
          v-show='form.infoType == 2'
          label="开始时间"
          prop='startTime'
        >
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        
        </el-col>
        <el-col :span="10" >
         
        <el-form-item
          v-show='form.infoType == 2'
          label="结束时间"
          prop='endTime'
        >
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>

        </el-col>
        
      </el-row>
      

          <el-form-item  v-show='form.infoType == 2'
            label="详情图片"
          >
            <el-upload
              class="upload-demo"
              :multiple='true'
              action="/manager/user/seven_app_file_up"
              :on-preview="handlePreview"
              :on-success="handleAvatarSuccess2"
              :on-remove="handleRemove1"
              :data='tokenData'
              :file-list="fileList3"
              list-type="picture"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：宽375px 高无限</div>
            </el-upload>
          </el-form-item>


        <el-form-item>
          <el-button
            type="primary"
            @click="editPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="新增"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="标题"
          prop='title'
        >
          <el-input v-model="form.title"></el-input>
        </el-form-item>
         <el-form-item

          label="排序值"
          prop='orderIndex'
        >
          <el-input v-model="form.orderIndex" type="number"></el-input>
        </el-form-item>

        <el-form-item
          label="积分"
          prop='integral'
        >
          <el-input v-model="form.integral"></el-input>
        </el-form-item>

         <el-form-item
          label="课程类型"
          prop="infoType"
        >
          <el-select
            v-model="form.infoType"
            placeholder="请选择"
          >
            <el-option
              v-for="option in recoOptions"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="课程类别"
          prop="stuType"
        >
          <el-select
            v-model="form.stuType"
            placeholder="请选择"
          >
            <el-option
              v-for="option in stuTypeList"
              :value="option.id"
              :key='option.id'
              :label="option.typeName"
            ></el-option>
          </el-select>
        </el-form-item>


               <el-form-item
 v-show='form.infoType == 1'
          label="时长"
          prop='videoTime'
        >
          <el-input type="number" v-model="form.videoTime"></el-input>
        </el-form-item>

        <el-form-item  v-show='form.infoType == 1' label="视频封面" prop="videoCover">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.videoCover" :src="form.videoCover" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

          <el-form-item  v-show='form.infoType == 1' label="主讲人头像" prop="speakHead">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess1"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.speakHead" :src="form.speakHead" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

          <el-form-item  v-show='form.infoType == 2' label="封面" prop="speakHead">
            <el-upload
              class="avatar-uploader"
              action="/manager/user/seven_app_file_up"
              :show-file-list="false"
              :data="tokenData"
              :on-success="handleAvatarSuccess1"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="form.speakHead" :src="form.speakHead" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，图片比例：365px × 165px</div>
            </el-upload>
          </el-form-item>

         <el-form-item
          label="主讲人"
          prop='speakUser'
        >
          <el-input v-model="form.speakUser"></el-input>
        </el-form-item>
        <el-form-item
          v-show='form.infoType == 1'
          label="对应角色"
          prop="roleType"
        >
          <el-select
            v-model="form.roleType"
            placeholder="请选择"
          >
            <el-option
              v-for="option in roleTypeList"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
        v-show='form.infoType == 1'
          label="视频连接"
          prop='videoUrl'
        >
          <el-input v-model="form.videoUrl"></el-input>
        </el-form-item>

        
      <el-form-item
        v-show='form.infoType == 2'
          label="总人数"
          prop='totalNum'
        >
          <el-input v-model="form.totalNum" type="number"></el-input>
        </el-form-item>
        <el-form-item
        v-show='form.infoType == 2'
          label="地点"
          prop='address'
        >
          <el-input v-model="form.address"></el-input>
        </el-form-item>

        <el-form-item
          v-show='form.infoType == 2'
          label="开始时间"
          prop='startTime'
        >
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        

        <el-form-item
          v-show='form.infoType == 2'
          label="结束时间"
          prop='endTime'
        >
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>

        
          <el-form-item  v-show='form.infoType == 2'
            label="详情图片"
          >
            <el-upload
              class="upload-demo"
              :multiple='true'
              action="/manager/user/seven_app_file_up"
              :on-preview="handlePreview"
              :on-success="handleAvatarSuccess2"
              :on-remove="handleRemove1"
              :data='tokenData'
              :file-list="fileList3"
              list-type="picture"
            >
              <el-button
                size="small"
                type="primary"
              >点击上传</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
              >只能上传jpg/png文件，图片比例：宽375px 高无限</div>
            </el-upload>
          </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    
    <el-dialog
      title="学习人员"
      :visible.sync="subListVisible"
      width="70%"
    >

      <div><el-button type="primary"
        @click="excelOut">导出</el-button></div>

      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="username"
          label="姓名"
        >
        </el-table-column>

        <el-table-column
          prop="buy_num"
          label="报名人数"
        >
        </el-table-column>

        <el-table-column
          prop="commend_info"
          label="备注"
        >
        </el-table-column>

        <el-table-column
          prop="integral"
          label="积分"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="手机号"
        >
        </el-table-column>
          <el-table-column label="代理头像">
            <template slot-scope="scope">
              <img
                :src="scope.row.user_head"
                style="width:50px;height:50px"
              >
            </template>
          </el-table-column>
        <el-table-column
          prop="role_type"
          :formatter="formatterRoleType"
          label="代理类型"
        >
        </el-table-column>
        <el-table-column
          prop="create_time1"
          label="时间"
        >
        </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange1"
          :current-page.sync="page_num1"
          :page-count='total_page1'
          :page-size="page_size1"
          layout="total, prev, pager, next"
          :total="total_num1"
        >
        </el-pagination>
      </div>

    </el-dialog>

    <el-dialog
      title="录入信息"
      :visible.sync="courseUserMsgListVisible"
      width="70%"
    >
    <div>
      <el-button
                @click="excelOutUserMsg()"
                type="primary"
              >导出</el-button>
    </div>
      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="loginUserName"
          label="申请人姓名"
        >
        </el-table-column>

        <el-table-column
          prop="username"
          label="姓名"
        >
        </el-table-column>

        <el-table-column
          prop="id_card"
          label="身份证号"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="手机号"
        >
        </el-table-column>

        <el-table-column
          prop="health_code"
          label="健康码"
        >
          <template slot-scope="scope">
            <img
                :src="scope.row.health_code"
                style="width:50px;"
              >
          </template>
        </el-table-column>

        <el-table-column
          prop="create_time1"
          label="时间"
        >
        </el-table-column>

      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange2"
          :current-page.sync="page_num1"
          :page-count='total_page1'
          :page-size="page_size1"
          layout="total, prev, pager, next"
          :total="total_num1"
        >
        </el-pagination>
      </div>

    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import QRCode from "qrcodejs2";
import { dateFunc } from "../../dateFunc";
import API from "../../api/api_user";
export default {
  name: "judgeTypeList",
  created() {},

  data() {
    return {
      subListVisible:false,
      courseId: null,
      page_size1:10,
      detailListLoading:false,
      tableDetailData:[],
      total_num1:0,
      total_page1:0,
      page_num1:1,
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      addFormRule: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" }
        ],
        orderIndex: [
          { required: true, message: "请输入排序值", trigger: "blur" }
        ],
        infoType: [
          { required: true, message: "请选择课程类型", trigger: "blur" }
        ],
      },
      addLoading: false,
      recoOptions: [
        { text: "线上", value: "1" },
        { text: "线下", value: "2" }
      ],
      roleTypeList: [
        // { text: "康减系列vip会员", value: "-0.5" },
        // { text: "康减系列高级会员", value: "-0.4" },
        // { text: "康减系列荣誉会员", value: "-0.3" },
        // { text: "康减系列市代", value: "1.1" },
        // { text: "康减系列省代", value: "2.1" },
        // { text: "康减系列CEO", value: "3.1" },
        { text: "VIP门店", value: "0" },
        { text: "联盟店", value: "1" },
        { text: "优秀联盟店", value: "1.05" },
        { text: "市代", value: "2" },
        { text: "省代", value: "3" },
        { text: "CEO", value: "4" },
        { text: "总经销商", value: "5" },
        { text: "合伙人", value: "2.2" },
        { text: "董事", value: "4.2" },
        { text: "区域总监", value: "5.1" },
        { text: "城市加盟商", value: "5.2" },
        { text: "经销商", value: "4.8" }
      ],
      stuTypeList:[],
      fileList3:[],
      loading: false,
      form: {
        videoCover:null,
        speakHead:null,
        videoTime:null,
        title: null,
        orderIndex: null,
        totalNum:null,
        infoType:null,
        speakUser:null,
        roleType:null,
        stuType:null,
        videoUrl:null,
        id: null,
        integral: 0,
        address: null,
        startTime: null,
        endTime: null,
      },
      fileList5:[],
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        status: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      dialogAddVisible: false,
      backFirst: 1,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null,
      courseUserMsgListVisible: null,
      chooseCourseId: null,
      detailPicList: [],
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
    this.getStuType();
  },
  methods: {
    excelOut(){
      var that = this;
      var url =
        "/manager/user/pc/course_user_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.courseId) {
        url = url + "&courseId=" + that.courseId;
      }
      top.location.href = url;
    },
    excelOutUserMsg(){
      var that = this;
      var url =
        "/manager/user/pc/course_user_msg_excel?token=" +
        localStorage.getItem("api_token");
      if (that.chooseCourseId) {
        url = url + "&courseId=" + that.chooseCourseId;
      }
      // window.open("http://localhost:8839"+url,'_blank')
      top.location.href = url;
    },
    creatQrCode(str) {
        this.dialogVisible = true
      setTimeout(() => {
        document.querySelector("#qrCodeUrl").innerHTML = ""
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: 'JSYMR:' + str.id + '', // 需要转换为二维码的内容
          width: 150,
          height: 150,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.qrcode.clear();
        this.qrcode.makeCode('JSYMR:' + str.id + '');
      }, 500)
    },
     formatterRoleType(row, column) {
       if(row.role_type == null)
       {return '--'}
      if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == -0.5) {
        return "康减系列";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      }  else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 1.05) {
        return "优秀门店";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      } else if (row.role_type == 4.8) {
        return "经销商";
      }
    },
    handleCurrentChange2(val) {
        this.searchCourseUserMsgDetail(this.chooseCourseId);
      },
      showUserMsg(row){
        let that = this;
        that.courseUserMsgListVisible = true;
        this.page_size1 = 10;
        this.page_num1 = 1;
        that.chooseCourseId = row.id
        this.searchCourseUserMsgDetail(row.id);
      },
      handleCurrentChange1(val) {
        this.searchDetail(this.courseId);
      },
    showStuUser(row) {
      let that = this;
      that.subListVisible = true;
      this.page_size1 = 10;
      this.page_num1 = 1;
      this.courseId = row.id
      this.searchDetail(row.id);
    },
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.videoCover = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    handleAvatarSuccess1: function(e) {
      if (e.key == 1000) {
        this.form.speakHead = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    searchDetail(courseId) {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        courseId:courseId,
        page_num: that.page_num1,
        page_size: that.page_size1
      };
      that.detailListLoading = true;
      API.stu_course_user_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num1 = result.result.count;
            that.total_page1 = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    
    handleRemove1(file, fileList) {
      var list = [];
      for (var i = 0; i < this.fileList5.length; i++) {
        if (this.fileList5[i].uid && this.fileList5[i].uid != null) {
          if (this.fileList5[i].uid != file.uid) {
            list.push(this.fileList5[i]);
          }
        } else {
          if (this.fileList5[i].name != file.name) {
            list.push(this.fileList5[i]);
          }
        }
      }
      this.fileList5 = list;
    },
    handleAvatarSuccess2: function(e, file) {
      if (e.key == 1000) {
        this.fileList5.push({
          uid: file.uid,
          name: file.name,
          url: e.result.map.path,
          height: e.result.map.height,
          width: e.result.map.width
        });

        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    searchCourseUserMsgDetail(courseId) {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        courseId:courseId,
        page_num: that.page_num1,
        page_size: that.page_size1
      };
      that.detailListLoading = true;
      API.course_user_msg_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            that.total_num1 = result.result.count;
            that.total_page1 = result.result.allPageNumber;
            if (result && parseInt(result.key) === 1000) {
              if (result.result.list != null && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time1 = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                }
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.subListLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          if (para.infoType == 1)
          {
            if (para.speakHead == null || para.videoCover == null || para.videoTime == null || para.roleType == null || para.stuType == null || para.videoUrl == null || para.speakUser == null)
            {
              that.$message.error({
                    showClose: true,
                    message: "请检查是否有内容未填写",
                    duration: 2000
                  });
              return false;
            }
          }
          if(para.startTime){
            para.startTime = para.startTime.getTime()
          }
          
          if(para.endTime){
            para.endTime = para.endTime.getTime()
          }
           if (that.fileList5.length == 0) {
            if (para.infoType == 2)
            {
              that.$message.error({
              showClose: true,
              message: "请上传详情图片",
              duration: 2000
            });
            return;
            }
          } else {
            var url = [];
            for (var i = 0; i< that.fileList5.length; i++)
            {
              url.push(that.fileList5[i].url);
            }
            para.pics = url.join(',');
            para.new_pics = JSON.stringify(that.fileList5);
          }
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.add_edit_stu_course(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });
                  that.dialogAddVisible = false;
                  that.addLoading = false;
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    editPost() {
      var that = this;
      let para = Object.assign({}, that.form);
      para.token = localStorage.getItem("api_token");
       if (para.infoType == 1)
          {
            if (para.speakHead == null || para.videoCover == null || para.videoTime == null || para.roleType == null || para.stuType == null || para.videoUrl == null || para.speakUser == null)
            {
              that.$message.error({
                    showClose: true,
                    message: "请检查是否有内容未填写",
                    duration: 2000
                  });
              return false;
            }
          }
          if(para.startTime){
            para.startTime = para.startTime.getTime()
          }
          
          if(para.endTime){
            para.endTime = para.endTime.getTime()
          }
          if (that.fileList5.length == 0) {
            if (para.infoType == 2)
            {
              that.$message.error({
              showClose: true,
              message: "请上传详情图片",
              duration: 2000
            });
            return;
            }
          } else {
            var url = [];
            for (var i = 0; i< that.fileList5.length; i++)
            {
              url.push(that.fileList5[i].url);
            }
            para.pics = url.join(',');
            para.new_pics = JSON.stringify(that.fileList5);
          }
      this.addLoading = true;
      API.add_edit_stu_course(para)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 1500
              });
              that.dialogEditVisible = false;
              that.addLoading = false;
              that.search();
            } else if (result.key == 1001) {
              bus.$emit("goto", "/login");
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.dialogEditVisible = false;
            that.addLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.dialogEditVisible = false;
          that.addLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addPostDialog() {
      this.form.title = null;
      this.form.id = null;
      this.form.orderIndex = null;
      this.form.infoType = null;
      this.form.stuType = null;
      this.form.videoUrl = null;
      this.form.speakUser = null;
      this.form.totalNum = null;
      this.form.videoCover = null;
      this.form.videoTime = null;
      this.form.roleType = null;
      this.form.speakHead = null;
      this.form.integral = null;
      this.form.address = null;
      this.form.startTime = null;
      this.form.endTime = null;
      this.dialogAddVisible = true;
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    handlePreview(file) {},
    editPostDialog(row) {
      this.form.id = row.id;
      this.form.title = row.title;
      this.form.orderIndex = row.order_index;
      this.form.infoType = row.info_type + '';
      this.form.roleType = row.role_type == null ? null : row.role_type + '';
      this.form.stuType = row.stu_type;
      this.form.videoUrl = row.video_url;
      this.form.videoCover = row.video_cover == '' || row.video_cover == null ? null : row.video_cover;
      this.form.speakHead = row.speak_head == '' || row.speak_head == null ? null : row.speak_head;
      this.form.videoTime = row.video_time == null || row.video_time == '' ? null : row.video_time;
      this.form.speakUser = row.speak_user;
      this.form.integral = row.integral;
      this.form.address = row.address;
      this.form.totalNum = row.total_num;
      this.form.startTime = row.start_time ? new Date(row.start_time) : null;
      this.form.endTime = row.end_time ? new Date(row.end_time) : null;
      var url2 = row.new_pics && row.new_pics != null && row.new_pics != '' ? JSON.parse(row.new_pics) : [];
      this.fileList5 = [];
      this.fileList3 = [];
      for (var i = 0; i < url2.length; i++) {
        this.fileList3.push({
          name: url2[i].path,
          url: url2[i].url,
          uid: url2[i].uid,
          height: url2[i].height,
          width: url2[i].width
        });
        this.fileList5.push({
          name: url2[i].path,
          url: url2[i].url,
          uid: url2[i].uid,
          height: url2[i].height,
          width: url2[i].width
        });
      }
      this.dialogEditVisible = true;
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 1) {
        m1 = "确定取消上架该课程吗？";
        m2 = "取消成功后，app就不显示该课程";
        m3 = "取消成功";
        type = "warning";
        this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id
          };
          API.down_stu_course(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
      } else if (status == 2) {
        m1 = "确定上架该课程吗？";
        m2 = "上架成功后，app就会显示该课程";
        m3 = "上架成功";
        type = "success";
        this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id
          };
          API.push_stu_course(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
      } else {
        m1 = "确定删除该课程吗？";
        m2 = "删除成功后，app和后台都不显示该课程";
        m3 = "删除成功";
        type = "error";
        this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            ids: row.id
          };
          API.del_stu_course(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
      }

    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        page_num: that.page_num,
        page_size: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if(that.filters.infoType){
        params.infoType = that.filters.infoType
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (
        that.filters.keyword &&
        that.filters.keyword != null &&
        that.filters.keyword != ""
      ) {
        params.keywords = that.filters.keyword;
      }
      that.loading = true;

        API.stu_course_list(params)
          .then(
            function(result) {
              that.loading = false;
              if (result.key == 1000) {
                that.total_num = result.result.count;
                that.total_page = result.result.allPageNumber;
                if (result.result.list && result.result.list.length > 0) {
                  for (var i = 0; i < result.result.list.length; i++) {
                    result.result.list[i].create_time = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].create_time)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                  }
                }
                that.tableData = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              }
            },
            function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    
    getStuType() {
      let that = this;
      let params = {
        pageNum: 1,
        pageSize: 100,
        token: localStorage.getItem("api_token")
      };
        API.stu_course_type_list(params)
          .then(
            function(result) {
              that.loading = false;
              if (result.key == 1000) {
                that.stuTypeList = result.result.list;
              } else if (result.key == 1001) {
                bus.$emit("goto", "/login");
              }
            },
            function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }
          )
          .catch(function(error) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: "请求出现异常",
              duration: 2000
            });
          });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {this.dialogVisible = false},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/stuCourseList.vue